import React, { useState } from 'react';
import 'react-image-gallery/styles/css/image-gallery.css';
import UserImage from '../../../assets/images/common/Icons/User.png';
import UserBlueIcon from '../assets/images/user_blue_icon.png';
import UserDoubleBlueIcon from '../assets/images/user_double_blue_icon.png';
import UserRedIcon from '../assets/images/red.png';

import { Cell } from 'react-sticky-table';
import { useGlobalState } from './GlobalState';
import axios from 'axios';
import { notification } from 'antd';
import { addToDateString } from '../../admin/components/bookings/components/SelectSwim';

export default function SelectSwim(props) {
  const [, setLoading] = useState(false);

  const [userSelectedRods] = useGlobalState('userSelectedRods');
  const [swimAvailableData] = useGlobalState('swimAvailableData');

  const [userSelectedAnglers] = useGlobalState('userSelectedAnglers');
  const [unSelectableSwimIds] = useGlobalState('unSelectableSwimIds');
  const [userSelectedPakage] = useGlobalState('userSelectedPakage');

  // user selected swims
  const [userSelectedSwims, setUserSelectedSwims] =
    useGlobalState('userSelectedSwims');
  const [, setUserBookingData] = useGlobalState('userBookingData');
  const [userSelectedDoubleSwim, setUserSelectedDoubleSwim] = useGlobalState(
    'userSelectedDoubleSwim'
  );
  const [bookingType] = useGlobalState('bookingType');

  const [userSelectedLakeId] = useGlobalState('userSelectedLakeId');
  const [, setEstimatedPricing] = useGlobalState('estimatedPricing');
  //
  const [lakeExclusive] = useGlobalState('lakeExclusive');
  const [arrivalTime] = useGlobalState('arrivalTime');
  const [departureTime] = useGlobalState('departureTime');
  const [lakeDetails] = useGlobalState('lakeDetails');

  const availableDSwims = swimAvailableData.double_swims;
  const selectedDates = swimAvailableData.selected_dates;
  const swim_id = props.swim_id;
  const date = props.date;
  const index = props.index;

  const axios_config = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  };

  const handleSwimChange = (e, swim) => {
    // Maintain local variables because of globalstate latency
    let local_variable_swim = userSelectedSwims;
    let local_variable_double_swim = userSelectedDoubleSwim;

    // Need not send request to API if it's a double swim
    let call_api = true;

    if (
      userSelectedSwims.length + userSelectedDoubleSwim.length <
      userSelectedAnglers
    ) {
      let index = userSelectedSwims.indexOf(swim);
      if (index !== -1) {
        let dsIndex = userSelectedDoubleSwim.indexOf(swim);
        if (availableDSwims.indexOf(swim) > -1 && dsIndex !== 0) {
          local_variable_double_swim = [...userSelectedDoubleSwim, swim];
          setUserSelectedDoubleSwim(local_variable_double_swim);
          // call_api = false;
        } else {
          if (dsIndex === 0) {
            userSelectedDoubleSwim.splice(dsIndex, 1);
            local_variable_double_swim = [...userSelectedDoubleSwim];
            setUserSelectedDoubleSwim(local_variable_double_swim);
          }
          userSelectedSwims.splice(index, 1);
          local_variable_swim = [...userSelectedSwims];
          setUserSelectedSwims(local_variable_swim);
        }
      } else {
        local_variable_swim = [...userSelectedSwims, swim];
        setUserSelectedSwims(local_variable_swim);
      }
    } else {
      setUserBookingData({});
      setUserSelectedSwims([]);
      setUserSelectedDoubleSwim([]);
      local_variable_swim = [];
      local_variable_double_swim = [];
    }

    if (call_api) {
      sendDataToServer(local_variable_swim.concat(local_variable_double_swim));
    }
  };

  const sendDataToServer = (swimList) => {
    let payload_data = {
      lake_id: userSelectedLakeId,
      arrival_timestamp: arrivalTime,
      departure_timestamp: departureTime,
      anglers: userSelectedAnglers,
      guest: userSelectedRods,
      swims: swimList,
      is_mobile_device: window.innerWidth <= 700,
      book_lake_exclusive: lakeExclusive,
      booking_type: bookingType,
      ...(userSelectedPakage && {
        custom_slot_id:
          lakeDetails?.custom_slot_days[userSelectedPakage - 1]?.id,
      }),
    };

    axios
      .post('booking/swim_ticket/availability', payload_data, axios_config)
      .then((res) => {
        if (res.status === 200) {
          setLoading(false);
        }
      })
      .catch((err) => {
        if (err.response) {
          if (err.response.status === 401 || err.response.status === 422) {
            notification.error({
              message: <div className='gSemiBold'>There was an issue!</div>,
              style: { border: '1px #D34545 solid' },
              placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
              className: 'gRegular br10',
              description: 'Please login to continue',
            });
          }
        } else {
          notification.error({
            message: <div className='gSemiBold'>There was an issue!</div>,
            style: { border: '1px #D34545 solid' },
            placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
            className: 'gRegular br10',
            description: 'Error processing result',
          });
        }
      })
      .finally(() => {});
  };

  const handleOnclickEvent = (
    e,
    isSelectedDates,
    isUnClickable,
    swim_id,
    date
  ) => {
    if (isSelectedDates) {
      if (isUnClickable) {
      } else {
        handleSwimChange(e, swim_id, date);
      }
    }
  };

  const isSelectedDates = selectedDates.indexOf(date) !== -1;
  const isAdjacentDate =
    selectedDates.indexOf(addToDateString(date, -1)) !== -1 ||
    selectedDates.indexOf(addToDateString(date, 1)) !== -1;
  if (
    swimAvailableData.booked_dates &&
    swimAvailableData.booked_dates[swim_id] &&
    swimAvailableData.booked_dates[swim_id].indexOf(date) > -1
  ) {
    return (
      <Cell
        className={
          (isSelectedDates ? 'bg-swim-user-selected-range ' : '') +
          (isSelectedDates || isAdjacentDate ? 'swim-user-adjacent-range' : '')
        }
        key={index}
      >
        <div>
          <img alt={swim_id + '#' + date} src={UserRedIcon} width={15} />
        </div>
      </Cell>
    );
  } else {
    const isUnClickable =
      unSelectableSwimIds && unSelectableSwimIds.indexOf(swim_id) > -1;
    const userSelectedIcon =
      userSelectedDoubleSwim.indexOf(swim_id) > -1 && isSelectedDates
        ? UserDoubleBlueIcon
        : userSelectedSwims.indexOf(swim_id) > -1 && isSelectedDates
          ? UserBlueIcon
          : UserImage;

    const userDoubleSelect =
      userSelectedDoubleSwim.indexOf(swim_id) > -1 && isSelectedDates;

    return (
      <Cell
        className={
          (isSelectedDates ? 'bg-swim-user-selected-range ' : '') +
          (isSelectedDates || isAdjacentDate ? 'swim-user-adjacent-range' : '')
        }
        key={index}
        onClick={(e) => {
          handleOnclickEvent(e, isSelectedDates, isUnClickable, swim_id, date);
        }}
        // (isSelectedDates && isUnClickable) ? (e) => {} : (e) => {handleSwimChange(e, swim_id, date)}
      >
        <div>
          <img
            // className = { userSelectedIcon  + " available-swim-date select-swim-user-image" }
            className={`${
              userDoubleSelect ? 'active-double' : ''
            } available-swim-date select-swim-user-image`}
            alt={swim_id + '#' + date}
            // src={UserImage}
            src={userSelectedIcon}
            // src={ (isSelectedDates && !isUnClickable) ? userSelectedIcon : UserRedIcon }
          />
        </div>
      </Cell>
    );
  }
}
